import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Gamepad2 } from 'lucide-react';

export default function AdminGames() {
    const [games, setGames] = useState([]);
    useEffect(() => { api.get('/games').then((r) => setGames(r.data)); }, []);
    return (
        <div data-testid="admin-games-page">
            <h1 className="font-display font-extrabold text-3xl text-slate-900">Learning Arcade</h1>
            <p className="text-sm text-slate-500 mt-1 mb-5">Manage gamification — 5 games active by default. AI game builder coming soon.</p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {games.map((g) => (
                    <div key={g.code} className="bg-white rounded-2xl border border-slate-200 overflow-hidden" data-testid={`admin-game-${g.code}`}>
                        <div className="aspect-video bg-slate-100">
                            {g.cover_image && <img src={g.cover_image} alt={g.name} className="w-full h-full object-cover" />}
                        </div>
                        <div className="p-4">
                            <div className="flex items-center gap-2"><Gamepad2 className="h-4 w-4 text-brand-blue" /><h3 className="font-display font-bold">{g.name}</h3></div>
                            <p className="text-xs text-slate-500 mt-1">{g.description}</p>
                            <div className="text-xs text-slate-600 mt-2"><b>Rules:</b> {g.rules}</div>
                            <div className="text-xs text-slate-600 mt-1">Points per play: <b>{g.points_per_play}</b></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
